import {Controller} from "stimulus"

export default class extends Controller {
  static values = {
    ecommerceGtagId: String,
    customEcommerceGtagId: String,
    body: Object
  }

  connect() {
    let ecomerceId = this.bodyValue['transaction_id']
    if(!localStorage.getItem(`gtag_${ecomerceId}`)) {
      if (this.ecommerceGtagIdValue) {
        let properties = Object.assign({}, this.bodyValue, {send_to: this.ecommerceGtagIdValue})
        gtag('event', 'purchase', properties)
      }
      if (this.customEcommerceGtagIdValue) {
        let properties = Object.assign({}, this.bodyValue, {send_to: this.customEcommerceGtagIdValue})
        gtag('event', 'purchase', properties)
      }
      localStorage.setItem(`gtag_${ecomerceId}`, 'true')
    }
  }
}
